"use client";

class HapticEngine {
    private ctx: AudioContext | null = null;

    private init() {
        if (typeof window === "undefined") return;
        if (!this.ctx) {
            this.ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
        }
        if (this.ctx.state === "suspended") {
            this.ctx.resume().catch(() => {});
        }
    }

    unlock() {
        try {
            this.init();
            if (this.ctx && this.ctx.state === "suspended") {
                // Play 1 sample of silence to satisfy iOS user-gesture requirement
                const buffer = this.ctx.createBuffer(1, 1, 22050);
                const source = this.ctx.createBufferSource();
                source.buffer = buffer;
                source.connect(this.ctx.destination);
                source.start(0);
                
                this.ctx.resume().catch(() => {});
            }
        } catch (e) {
            // Ignore
        }
    }

    hover() {
        try {
            this.init();
            if (!this.ctx || this.ctx.state === "suspended") return;

            const now = this.ctx.currentTime;
            const osc = this.ctx.createOscillator();
            const gainNode = this.ctx.createGain();

            osc.connect(gainNode);
            gainNode.connect(this.ctx.destination);

            osc.type = "sine";
            // Whisper-soft, high-frequency focus pluck
            osc.frequency.setValueAtTime(1400, now);
            
            gainNode.gain.setValueAtTime(0.003, now); // extremely soft/whisper level
            gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.035);

            osc.start(now);
            osc.stop(now + 0.035);
        } catch (e) {
            // Audio context not allowed or blocked
        }
    }

    click() {
        try {
            // Perform physical vibration on Android devices supporting vibration API
            if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
                navigator.vibrate(12); // brief crisp mechanical haptic tick
            }
        } catch (e) {}

        try {
            this.init();
            if (!this.ctx || this.ctx.state === "suspended") return;

            const now = this.ctx.currentTime;
            const osc = this.ctx.createOscillator();
            const gainNode = this.ctx.createGain();

            osc.connect(gainNode);
            gainNode.connect(this.ctx.destination);

            osc.type = "sine";
            // Soft double-pulse click
            osc.frequency.setValueAtTime(650, now);
            osc.frequency.exponentialRampToValueAtTime(320, now + 0.05);

            gainNode.gain.setValueAtTime(0.012, now);
            gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.05);

            osc.start(now);
            osc.stop(now + 0.05);
        } catch (e) {
            // Ignore
        }
    }
}

export const haptics = new HapticEngine();
